export const createMeta = ({ title, description, keywords, image }) => ({
  meta: [
    { vmid: 'title', content: title },
    { vmid: 'description', content: description },
    { vmid: 'keywords', content: keywords },
    { vmid: 'image', content: image },
  ],
});
